import React, { useState, useEffect } from "react";
import { Row, Col, FormLabel } from "react-bootstrap";
import backArrow from "../images/arrow-back.svg";

// import Button from "react-bootstrap/Button";
import { InputGroup, FormControl, Button } from "react-bootstrap"

import Carousel from 'react-bootstrap/Carousel';
import GitchaMobileLogo from "../images/gitcha-mobile-logo.svg";
import CarouselImage from "../images/carousel-img-1.png";

import Select from "react-select";



const SignUp = (props) => {
  

  return (
    <div className="mobile-wrapper bg-white">

      <div className="mobile-wrapper-inner bg-white">
        <div className="signup-header">
        <a href="#"> <img src={backArrow} /></a>
          <h2>Sign up or log-in</h2>
          <p>Confirm your email to continue. </p>
        </div>

        <div className="input-group mb-3">
          <FormLabel>Email</FormLabel>
                  <input aria-label="Example" aria-describedby="basic-addon3" placeholder="Client name" className="form-control" value="" />
                  <button type="button" id="button-addon3" className="search-icon btn btn-primary"></button>
                </div>

        <Button className="btn-secondary disabled w-100">
            Continue
        </Button>
        
        
        
      </div>
    </div>
  );
};

export default SignUp;
